const getLabelID = (label_info) => {
	if(label_info === null || label_info === undefined) return null;
	if(typeof label_info === 'object')
	{
		return ('label_id' in label_info) ? label_info.label_id : null;
	}
	return label_info;
};

export const buildLabelsById = (labels = []) => {
	return labels.reduce((result, label_info) => {
		if(!label_info) return result;
		const label_id = getLabelID(label_info);
		if(!label_id) return result;
		result[label_id] = label_info;
		return result;
	}, {});
};

export const buildCourseSectionLabelMap = (sections = []) => {
	return sections.reduce((result, section_info) => {
		if(!section_info || !section_info.course_id) return result;

		const course_id = section_info.course_id;
		const section_labels = Array.isArray(section_info.labels) ? section_info.labels : [];

		if(!(course_id in result)) result[course_id] = new Set();

		section_labels.forEach((label_info) => {
			const label_id = getLabelID(label_info);
			if(label_id) result[course_id].add(label_id);
		});

		return result;
	}, {});
};

export const getStudentApplicableLabelIdsForCourse = (student_labels = [], course_id, course_section_label_map = {}) => {
	if(!course_id) return [];
	const course_label_set = course_section_label_map[course_id];
	if(!course_label_set || course_label_set.size === 0) return [];

	const seen_labels = new Set();
	return student_labels.reduce((result, student_label_info) => {
		const label_id = getLabelID(student_label_info);
		if(!label_id || !course_label_set.has(label_id) || seen_labels.has(label_id)) return result;

		seen_labels.add(label_id);
		result.push(label_id);
		return result;
	}, []);
};

export const getVisibleRequestLabels = ({student_labels = [], course_id, course_section_label_map = {}, labels_by_id = {}}) => {
	const visible_label_ids = getStudentApplicableLabelIdsForCourse(student_labels, course_id, course_section_label_map);
	return visible_label_ids.reduce((result, label_id) => {
		if(!(label_id in labels_by_id)) return result;
		result.push(labels_by_id[label_id]);
		return result;
	}, []);
};

export const sectionSatisfiesStudentLabelsForCourse = ({section_label_ids = [], student_labels = [], course_id, course_section_label_map = {}}) => {
	const labels_needed = getStudentApplicableLabelIdsForCourse(student_labels, course_id, course_section_label_map);
	if(labels_needed.length === 0) return true;

	const section_label_set = new Set((section_label_ids || []).map(label_info => getLabelID(label_info)).filter(Boolean));
	return labels_needed.every(label_id => section_label_set.has(label_id));
};
